import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {DragulaModule} from 'ng2-dragula';
import {CoreModule} from '../core/core.module';
import {MaterialModule} from '../material.module';
import {DiagramCanvasComponent} from './diagram-canvas/diagram-canvas.component';
import {DiagramCanvasService} from './diagram-canvas/diagram-canvas.service';
import {DynamicCSSPropertiesDirective} from './helpers/dynamic-css-properties.directive';
import {FlowlineHelperService} from './helpers/flowline-helper.service';
import {GraphHelperService} from './helpers/graph-helper.service';
import {HiddenResourceFilterPipe} from './helpers/hidden-resource-filter.pipe';
import {InterpolatePipe} from './helpers/interpolate.pipe';
import {UserGroupsFilterPipe} from './helpers/user-groups-filter.pipe';
import {AngularComponentService} from './mx-graph/graph/angular-component.service';
import {MxGraphModule} from './mx-graph/mx-graph.module';
import {ResourceTypePipe} from './pipes/resource-type.pipe';
import {SfaHeaderComponent} from './sfa-header/sfa-header.component';
import {SfaHeaderService} from './sfa-header/sfa-header.service';
import {ActivityShapeComponent} from './shapes/activity-shape/activity-shape.component';
import {OrgModelLinkComponent} from './shapes/activity-shape/org-model-link/org-model-link.component';
import {ActivityPaperclipComponent} from './shapes/activity-shape/paper-clip/activity-paperclip.component';
import {ConnectorShapeComponent} from './shapes/connector-shape/connector-shape.component';
import {ShapeSpawnerService} from './shapes/shape-spawner.service';
import {ShapesTemplateService} from './shapes/shapes-template.service';
import {StylesService} from './styles/styles.service';

@NgModule({
  imports: [
    CommonModule,
    MxGraphModule,
    TranslateModule,
    DragulaModule,
    CoreModule,
    MaterialModule,
    DiagramCanvasComponent,
    ActivityShapeComponent,
    ConnectorShapeComponent,
    ActivityPaperclipComponent,
    HiddenResourceFilterPipe,
    InterpolatePipe,
    UserGroupsFilterPipe,
    OrgModelLinkComponent,
    ResourceTypePipe,
    SfaHeaderComponent,
    DynamicCSSPropertiesDirective
  ],
  providers: [
    DiagramCanvasService,
    StylesService,
    ShapesTemplateService,
    AngularComponentService,
    FlowlineHelperService,
    GraphHelperService,
    ShapeSpawnerService,
    SfaHeaderService
  ]
})
export class DiagramRenderModule {}
